var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localScrollValue),expression:"localScrollValue"}],staticClass:"slider pointer mb-3",attrs:{"type":"range","min":0,"max":_vm.scrollMax,"id":""},domProps:{"value":(_vm.localScrollValue)},on:{"input":_vm.onSliderInput,"__r":function($event){_vm.localScrollValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }